/**
 * 防止管道串用，请每个模块单独管理并声明
 */
import mitt from 'mitt';

// type EventMap = Record<string | symbol, unknown>;

/**
 * P2P模块 以ws推送更新为主
 */
export const p2pEventBus = mitt();

export const p2pCommonEventBus = mitt(); // 通用事件总线

// export const notificationEventBus = mitt();
// export const authEventBus = mitt();